<li class="m-menu-item"
    :class="{'m--is-selected': selected,
             'm--is-disabled': isDisabled,
             'm--is-group': group,
             'm--is-open': propOpen,
             'm--is-custom-content': $slots['content'],
             'm--is-inside-group': insideGroup}"
    role="none">
    <router-link class="m-menu-item__link"
                 :class="{'m--is-disabled': isDisabled}"
                 :to="url"
                 @click="onClick"
                 :aria-selected="selected"
                 role="menuitem"
                 v-if="isUrl">
        <m-icon class="m-menu-item__icon"
                v-if="iconName"
                :name="iconName"
                size="1em"
                ref="icon"></m-icon>
        <span class="m-menu-item__label">{{ label }}</span>
    </router-link>
    <span class="m-menu-item__link"
          :class="{ 'm--is-disabled': isDisabled,
                    'm--is-custom-content': $slots['content']}"
          @click="onClick"
          @keypress.enter="onClick"
          :tabindex="isDisabled ? '-1' : '0'"
          :aria-selected="selected"
          :aria-haspopup="group"
          :aria-controls="group ? ariaControls : undefined"
          :aria-expanded="group ? propOpen : undefined"
          v-else>
        <slot name="content">
            <m-icon class="m-menu-item__icon"
                    v-if="iconName"
                    :name="iconName"
                    ref="icon"
                    size="1em"></m-icon>
            <span class="m-menu-item__label">{{ label }}</span>
            <m-plus class="m-menu-item__plus"
                    skin="current-color"
                    :open="propOpen"
                    :large="selected"
                    ref="plus"
                    v-if="group"></m-plus>
        </slot>
    </span>
    <m-accordion-transition :disabled="!animReady || isDisabled"
                            ref="transition">
        <ul :id="ariaControls"
            class="m-menu-item__group"
            ref="group"
            :aria-hidden="!propOpen"
            v-show="propOpen">
            <slot></slot>
        </ul>
    </m-accordion-transition>
</li>
